
<template>
  <sui-page>
    <sui-page-header title="sui-text-field" />
    <sui-page-contents>
      <sui-showcase-manual-box :raw-file="component">
        <sui-showcase-box
          title="Default usage"
          :raw-file="sourceB1"
          collapsible
        >
          <sample-b1 />
        </sui-showcase-box>
        <sui-showcase-box
          title="Search Input"
          :raw-file="sourceB2"
          collapsible
        >
          <sample-b2 />
        </sui-showcase-box>
        <sui-showcase-box
          title="Password"
          :raw-file="sourceB3"
          collapsible
        >
          <sample-b3 />
        </sui-showcase-box>
        <sui-showcase-box
          title="Text-field w/ form"
          :raw-file="sourceB4"
          collapsible
        >
          <sample-b4 />
        </sui-showcase-box>
      </sui-showcase-manual-box>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import component from '!raw-loader!~common/components/form/SuiTextField/SuiTextField';

import sampleB1 from             "./sample/sampleB1";
import sourceB1 from '!raw-loader!./sample/sampleB1';
import sampleB2 from             './sample/sampleB2';
import sourceB2 from '!raw-loader!./sample/sampleB2';
import sampleB3 from             './sample/sampleB3';
import sourceB3 from '!raw-loader!./sample/sampleB3';
import sampleB4 from             './sample/sampleB4';
import sourceB4 from '!raw-loader!./sample/sampleB4';

export default {
  name: 'ManualTextField',
  components: {
    sampleB1,
    sampleB2,
    sampleB3,
    sampleB4,
  },
  data() {
    return {
      component,
      sourceB1,
      sourceB2,
      sourceB3,
      sourceB4,
    };
  },
};
</script>
